// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"120fac73","3641":"1404cf7d","6701":"99bed85d","8949":"1404cf7d"}[chunkId] + ".chunk.css";
};